<template>
  <div class="auth">
    <transition name="auth-router" mode="out-in">
      <router-view class="router" />
    </transition>
  </div>
</template>

<script>
export default {
  name: "auth",
};
</script>

<style lang="scss" scoped>
.auth {
  min-height: 120vh;
  display: flex;
  flex-direction: column;
  background-repeat: no-repeat;
  background-size: contain;
  background: -webkit-gradient(
    linear,
    left top,
    right bottom,
    color-stop(0%, #25b9ff),
    color-stop(100%, #0090e6)
  );
}
</style>
